export const hostUrl = `${process.env.REACT_APP_HOST_NAME}`;
